import { HTMLAttributes, ReactNode } from 'react';
import { Typography } from '../../atoms/typography/typography';
import { TypographyVariants } from '../../atoms/typography/variants';
import { match } from 'ts-pattern';

type Props = {
  title: string;
  titleSize?: TypographyVariants['variant'];
  children: ReactNode;
  action?: ReactNode;
} & Omit<HTMLAttributes<HTMLDivElement>, 'children'>;

export function SectionWithHeader(props: Props) {
  const { title, titleSize = 'body-s', action, children, ...rest } = props;

  return (
    <section {...rest}>
      {/* Header */}
      <div className="flex justify-between items-center">
        {/* Title */}
        <Typography
          as="h2"
          variant={titleSize}
          weight="medium"
          className={mapTitleSizeToColor(titleSize)}
        >
          {title}
        </Typography>

        {/* Action (optional) */}
        {action && action}
      </div>

      {/* Card Content */}
      <div className={mapTitleSizeToContentMargin(titleSize)}>{children}</div>
    </section>
  );
}

function mapTitleSizeToContentMargin(size: TypographyVariants['variant']) {
  return match(size)
    .returnType<string>()
    .with('body-l', () => 'mt-24')
    .otherwise(() => 'mt-12');
}

function mapTitleSizeToColor(size: TypographyVariants['variant']) {
  return match(size)
    .returnType<string>()
    .with('body-l', () => 'text-primaryMain')
    .otherwise(() => 'text-grayscale600');
}
